export const setWorkspaceSize = (width, height) => ({
    type: 'SET_WORKSPACE_SIZE',
    width,
    height,
    // meta: {
    //     throttle: 1000/30
    // }
})
export const setPan = (panX, panY) => ({
    type: 'SET_PAN',
    panX,
    panY,
    // meta: {
    //     throttle: 1000/30
    // }
})
export const panBy = (dx, dy) => ({
    type: 'PAN_BY',
    dx,
    dy,
    // meta: {
    //     throttle: 1000/30
    // }
})
export const setZoom = (z, targetZ, error) => ({
    type: 'SET_ZOOM',
    z,
    targetZ,
    error
    // meta: {
    //     throttle: 1000/30
    // }
})

export const zoomBy = (delta) => ({
    type: 'ZOOM_BY',
    //dz:  Math.pow(1.0005, -delta), //
    dz: Math.pow(2, -delta) //
})

export const resetPanZoom = () => ({ type: 'RESET_PAN_ZOOM' });
export const resetZoom = () => ({ type: 'RESET_ZOOM' });

export default {
    setWorkspaceSize,
    setPan,
    panBy,
    setZoom,
    zoomBy,
    resetPanZoom,
    resetZoom
}